import { Autocomplete } from 'stimulus-autocomplete'

// Connects to data-controller="autocomplete"
export default class extends Autocomplete {

  buildURL(query) {
    const args = {
      "terr": "METROPOLE",
      "poiType": "administratif",
      "maximumResponses": 10,
      "text": query
    }

    const params = new URLSearchParams(args);

    const url = `${this.urlValue}?${params.toString()}`;
    return url;
  }
}
